// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"678":"af0f883d","756":"08d79d62","788":"3fb0912b","799":"ea4e9e84","956":"56f51575"}[chunkId] + ".css";
};